import { combineReducers } from "redux"

import payment from "./payment-modal"
import recurring from "./recurring-reservations"

export default combineReducers({
  payment,
  recurring,
})
